import { useEffect, useState } from 'react'
import { useWindowDimensions } from '../hooks/useWindowDimensions'
import { isPhone } from '../common/constants'

interface Props {
  children: React.ReactNode
}

// https://developers.google.com/maps/documentation/javascript/react-map

export function SubLayout({ children }: Props) {
  // const { GOOGLE_MAPS_API_KEY } = env
  const { width, height } = useWindowDimensions()

  const [mapWidth, setMapWidth] = useState(100)
  const [mapHeight, setMapHeight] = useState(100)

  const isMobilePortraitMode = isPhone && width < height

  useEffect(() => {
    if (isPhone) {
      if (isMobilePortraitMode) {
        setMapWidth(width - 30)
        setMapHeight(height - 30)
      } else {
        setMapWidth(width - 60)
        setMapHeight(height - 20)
      }
    } else {
      setMapWidth(width - 275)
      setMapHeight(height - 50)
    }
  }, [width, height]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="mt-2" style={{ width: `${mapWidth}px`, height: `${mapHeight}px` }}>
      {children}
    </div>
  )
}
